import styled from 'styled-components'
import { Props } from './index';

const ListPageCategoryTitleContainer = styled.div<Props>`
  width: 100%;
`
export { ListPageCategoryTitleContainer }